<template>
    <v-card class="mx-auto">
        <div class="tile-list">
            <div
                v-for="app_block in filteredAppBlocks"
                :key="app_block.id"
                ripple
                class="tile-list__item"
            >
                <router-link
                    class="tile-list__link"
                    :aria-label="app_block.title"
                    :class="app_block.id"
                    :to="{
                        name: 'cms_page',
                        params: { id: app_block.cms_page_id },
                    }"
                    data-cypress-value="info__app-block"
                >
                    <div class="tile-list__icon">
                        <img
                            v-if="app_block._attachments"
                            class="tile-list__icon-image"
                            :src="
                                'data:' +
                                    app_block._attachments.image.content_type +
                                    ';base64,' +
                                    app_block._attachments.image.data
                            "
                            alt=""
                        />
                    </div>

                    <div class="tile-list__text" :class="app_block.id">
                        <h3 v-html="app_block.title"></h3>
                    </div>
                </router-link>
            </div>
        </div>
    </v-card>
</template>

<script>
import hubbdata from "@/hubbdata";
import router from "../router/index.js";

export default {
    computed: {
        hubbdata() {
            return hubbdata.getters.data;
        },
        cms_pages() {
            return hubbdata.state.cms_pages;
        },
        app_blocks() {
            return hubbdata.state.app_blocks;
        },
        filteredAppBlocks() {
            return this.app_blocks.filter(
                (app_block) =>
                    app_block.id !== "category_4447" &&
                    this.cms_page_exists(app_block),
            );
        },
        root_cms_pages() {
            return hubbdata.getters.rootCmsPages;
        },
        translations() {
            return hubbdata.getters.translations;
        },
        rootcategories() {
            return hubbdata.getters.getRootCategories;
        },
    },
    methods: {
        cms_page_exists(app_block) {
            let existing_page = this.cms_pages.find(
                (page) => app_block.cms_page_id == page.id,
            );
            if (existing_page !== undefined) {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        if (localStorage.getItem("terms_accepted") === null) {
            router.push("/welcome");
        }
    },
    mounted() {
        ga("set", "title", "Home"); // eslint-disable-line
        ga("send", "pageview", location.href); // eslint-disable-line

        hubbdata.dispatch("initDB");
    },
};
</script>

<style lang="scss" scoped>
.v-list-item__chevron {
    position: absolute;
    right: 10px;
}

.v-sheet {
    box-shadow: none !important;
}

.home {
    &__strapline-text {
        text-align: center;
        padding: 0px 10px 10px 10px;
    }

    &__logo img {
        height: 100px;
    }
}

.tile-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 3px;
    grid-row-gap: 3px;
    max-width: 500px;
    margin: 0 auto;
    padding: 1px;
    margin-top: 30px;

    @media screen and (min-width: 1100px) {
        max-width: 750px;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(2, 1fr);
    }

    &__link {
        text-decoration: none;
        flex: 50%;
        overflow: hidden;
    }

    &__icon {
        margin: 0px;
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    &__item {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 !important;
        height: 100%;
        width: 100%;
        min-height: unset !important;
    }

    &__icon-image {
        padding: 0 !important;
    }

    &__text {
        display: flex;
        align-items: center;
        z-index: 4;
        width: 80%;
        min-height: 50px;
        padding-bottom: 5px;
        margin: -100px 0px 0px 0px;
        color: white;

        h3 {
            z-index: 3;
            font-size: 22px;
            font-weight: bold;
            line-height: 1.1;
            // word-break: break-word;

            @media (min-width: 700px) {
                font-size: 24px;
            }

            @media (max-width: 390px) {
                font-size: 20px;
            }

            @media (max-width: 360px) {
                font-size: 18px;
            }

            @media (max-width: 330px) {
                font-size: 16px;
            }
            @media (max-width: 305px) {
                font-size: 14px;
            }
        }

        // leaving care
        &.app_block_200,
        &.app_block_181,
        &.app_block_221 {
            position: absolute;
            top: 160px;
            left: 20px;
            h3 {
                text-align: left;
                color: white;
            }

            @media (max-width: 305px) {
                top: 120px;
            }
        }

        //education employment training
        &.app_block_181,
        &.app_block_222,
        &.app_block_223 {
            position: absolute;
            height: 200px;
            top: 60px;
            left: 20px;
        }

        // financial support
        &.app_block_206,
        &.app_block_540 {
            position: absolute;
            top: 150px;
            left: 20px;
        }

        //your personal adviser
        &.app_block_182 {
            position: absolute;
            top: 190px;
            max-width: 60%;
            right: 20px;
            h3 {
                text-align: right;
            }

            @media (max-width: 345px) {
                top: 160px;
            }

            @media (max-width: 305px) {
                top: 140px;
            }
        }

        // health and wellbeing
        &.app_block_208,
        &.app_block_542 {
            max-width: 70%;
            position: absolute;
            top: 160px;
            right: 20px;
            h3 {
                text-align: right;
            }

            @media (max-width: 305px) {
                top: 140px;
            }
        }

        // your views + financial support
        &.app_block_207,
        &.app_block_206,
        &.app_block_540 {
            max-width: 80%;
            position: absolute;
            top: 130px;
            left: 20px;
            h3 {
                text-align: left;
                width: 100%;
                color: black;
            }
        }
    }
}

.category_4447 {
    display: none;
}
</style>
